<template>
  <div class="video-player" :style="{ height: isFirstRow && containerWidth < 610 ? 'auto' : 'auto' }">
    <link rel="stylesheet" href="https://cdn.plyr.io/3.7.8/plyr.css" />
    <template v-if="booleanIsFromMexico || getIsGSUser">
      <div v-if="isModalMode">
        <div v-show="currentPlayer === 'plyr1m'" :class="{ 'plyr-controls': playerClass }">
          <video preload="metadata" id="plyr1m" playsinline controls></video>
        </div>
        <div v-show="currentPlayer === 'plyr2m'" :class="{ 'plyr-controls': playerClass }">
          <video preload="metadata" id="plyr2m" playsinline controls></video>
        </div>
        <div v-show="currentPlayer === 'plyr3m'" :class="{ 'plyr-controls': playerClass }">
          <video preload="metadata" id="plyr3m" playsinline controls></video>
        </div>
      </div>
      <div v-else>
        <div v-show="currentPlayer === 'plyr1'" :class="{ 'plyr-controls': playerClass }">
          <video preload="metadata" id="plyr1" playsinline controls></video>
        </div>
        <div v-show="currentPlayer === 'plyr2'" :class="{ 'plyr-controls': playerClass }">
          <video preload="metadata" id="plyr2" playsinline controls></video>
        </div>
        <div v-show="currentPlayer === 'plyr3'" :class="{ 'plyr-controls': playerClass }">
          <video preload="metadata" id="plyr3" playsinline controls></video>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="country-block">
        <div class="content">
          <div>El vídeo no está disponible en tu región</div>
        </div>
      </div>
    </template>
    <!--    <div class="video-player__play-buttons">
      <Controls
        :container-width="containerWidth"
        :is-first-row="isFirstRow"
        :plays-type-selected="playsTypeSelected"
        :is-modal-mode="isModalMode"
        :are-types-hidden="areTypesHidden"
        @click-jump="onMoveToPlayClicked"
        @click-retro="$emit('click-retro')"
        @change-type="$emit('change-type', $event)"
        @change-retro="$emit('change-retro', $event)"
        @show-list="$emit('show-list')"
      />
    </div>-->
  </div>
</template>

<script>
import EventBus from '@/utils/event-bus';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'VideoPlayer',
  components: {
    // Controls: () => import('@/components/Sections/MediaPlayer-v2/Controls'),
  },
  props: {
    playerQueue: {
      type: Array,
      default: () => [],
    },
    isV2: {
      type: Boolean,
      default: false,
    },
    containerWidth: {
      type: Number,
      default: 1024,
    },
    gameIdSelected: {
      type: Number,
      default: 0,
    },
    isGs: {
      type: Boolean,
      default: false,
    },
    isFirstRow: {
      type: Boolean,
      default: false,
    },
    playsTypeSelected: {
      type: Number,
      default: 1,
    },
    isAutoPlay: {
      type: Boolean,
      default: false,
    },
    isModalMode: {
      type: Boolean,
      default: false,
    },
    areTypesHidden: {
      type: Boolean,
      default: false,
    },
    isPlaySeekerMode: {
      type: Boolean,
      default: false,
    },
    playSync: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      currentPlayer: 'plyr1',
      url1:
        'https://golstats.blob.core.windows.net/renders-correccion-2020/64930-12441-0002-Silva%20Diaz,%20Jordan-Pases%20acertados%20c.%20propia.mp4',
      url2: 'https://golstatsbets.blob.core.windows.net/video-player/67568_1.mp4',
      url3: 'https://golstats.blob.core.windows.net/video-reproductor-b2c/67568_1.mp4',
      baseUrl1: 'https://golstats.blob.core.windows.net/video-reproductor-b2c',
      baseUrl: 'https://golstatsbets.blob.core.windows.net/video-player',
      plyr1Src: '',
      plyr2Src: '',
      plyr3Src: '',
      plyr4Src: '',
      plyr1: null,
      plyr2: null,
      plyr3: null,
      plyr4: null,
      plyr1m: null,
      plyr2m: null,
      plyr3m: null,
      plyr4m: null,
      plyr1Name: '',
      plyr2Name: '',
      plyr3Name: '',
      buttonTypes: [
        {
          type: 'last',
          text: 'Jugada Anterior',
          textMobile: 'Jugada Ant.',
          imgSrc: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn-player-back.svg',
        },
        {
          type: 'next',
          text: 'Siguiente Jugada',
          textMobile: 'Sig. Jugada',
          imgSrc: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn-player-next.svg',
        },
      ],
      buttonTypesV2: [
        {
          type: 'last',
          text: 'Anterior',
          textMobile: 'Anterior',
          imgSrc: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn-player-back-green.svg',
        },
        {
          type: 'next',
          text: 'Siguiente',
          textMobile: 'Siguiente',
          imgSrc: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn-player-next-green.svg',
        },
      ],
      currentPlayIndex: 0,
      currentPlay: {},
      alreadyChanged: false,
      pivotPlayers: {
        current: null,
        last: null,
        next: null,
      },
      maxPlaysWithoutInteraction: 10,
      // todo: check on loaded data called twice at first load
      autoPlaysCount: -1,
      isAutoPlayLocal: false,
      keyP1: 1,
      keyP2: 1,
      keyP3: 1,
      pendingPlayerQueue: [],
      storeModule: this.isModalMode ? 'mediaModal' : 'mediaGeneral',
      booleanAlreadySync: false,
    };
  },
  computed: {
    ...mapState('loginGeneral', ['booleanIsFromMexico']),
    ...mapGetters('loginGeneral', ['getIsGSUser']),
    playlistIndex() {
      return this.$store.state[`${this.storeModule}`].playlistIndex;
    },
    playerType() {
      return this.$store.state[`${this.storeModule}`].playerType;
    },
    playlistGameId() {
      return this.$store.state[`${this.storeModule}`].playlistGameId;
    },
    isModalOpen() {
      return this.$store.state.mediaModal.isModalOpen;
    },
    lastPlayIndex() {
      return this.currentPlayIndex - 1;
    },
    nextPlayIndex() {
      return this.currentPlayIndex + 1;
    },
    playerClass() {
      return this.$route.name === 'mediaplayer2';
    },
    buttons() {
      return this.isV2 ? this.buttonTypesV2 : this.buttonTypes;
    },
  },
  watch: {
    playerQueue: {
      immediate: true,
      handler(newValue) {
        this.currentPlayIndex = 0;
        if (this.plyr1Name) {
          this.applyPlayerQueueHandler(newValue);
        } else {
          this.pendingPlayerQueue = newValue;
        }
      },
    },
    isModalOpen(newValue) {
      if (!newValue) {
        this.resetPlayersSrc();
      } else if (!this.isModalMode) {
        this.pausePlayers();
      }
    },
    currentPlay: {
      deep: true,
      handler(newValue) {
        this.$emit('play-changed', newValue);
      },
    },
    autoPlaysCount(newValue) {
      if (newValue > this.maxPlaysWithoutInteraction) {
        this.pausePlayers();
        this.setAutoPlaysCount(0);
        this.$emit('max-inactivity-reached');
      }
    },
    gameIdSelected(newValue) {
      if (this.playerQueue[this.currentPlayIndex].gameId !== newValue) {
        this.moveToGamePlays(newValue);
      }
    },
    isAutoPlay(newValue) {
      if (newValue !== this.isAutoPlayLocal) {
        this.isAutoPlayLocal = newValue;
      }
    },
    playlistIndex: {
      immediate: true,
      handler(newValue) {
        if (newValue !== this.currentPlayIndex) {
          if (this.isPlaySeekerMode) {
            this.setUpPlayInteraction(true);
          }
          this.setAutoPlaysCount(-1);
          this.resetPlayersSrc();
          this.currentPlayIndex = newValue;
          this.setPlyrSrc();
        }
      },
    },
    currentPlayIndex(newValue) {
      if (newValue !== this.playlistIndex) {
        this.$store.commit(`${this.storeModule}/setPlaylistIndex`, {
          mediaPlayerType: null,
          playlistIndex: newValue,
        });
      }
    },
  },
  methods: {
    getCurrentPlayerPlayInfo() {
      return {
        objectCurrentPlay: this[this.currentPlayer].gamePlay,
        numberCurrentTime: this[this.currentPlayer].currentTime,
      };
    },
    plyrInit() {
      for (let i = 1; i < 4; i++) {
        const plyrElement = `plyr${i}${this.isModalMode ? 'm' : ''}`;
        this.setPlyrNames(i, plyrElement);
        this[plyrElement] = new window.Plyr(document.getElementById(plyrElement), this.getPlyrOptions());
        this[plyrElement].on('loadeddata', this.getOnLoadedData(this[plyrElement], plyrElement));
        this[plyrElement].on('timeupdate', this.onTimeUpdate(plyrElement));
        this[plyrElement].on('playing', this.getOnPlaying());
        this[plyrElement].on('play', this.getOnPlay());
        this[plyrElement].on('pause', this.getOnPause());
        this[plyrElement].id = i;
        if (this.pendingPlayerQueue.length) {
          this.applyPlayerQueueHandler(this.pendingPlayerQueue);
        }
      }
    },
    applyPlayerQueueHandler(playerQueue) {
      this.setAutoPlaysCount(-1);
      this.resetPlayersSrc();
      if (playerQueue && playerQueue.length) {
        if (!this.isPlaySeekerMode && !playerQueue[0].booleanIsFullGame) {
          // const playIndex = playerQueue.findIndex(play => play.game.id === this.playlistGameId);
          // this.currentPlayIndex =
          //   this.isModalMode && this.playerType === 1 && this.playlistGameId ? (playIndex !== -1 ? playIndex : 0) : 0;
        }
        this.setPlyrSrc();
      }
    },
    setPlyrNames(index, name) {
      switch (index) {
        case 1:
          this.plyr1Name = name;
          break;
        case 2:
          this.plyr2Name = name;
          break;
        case 3:
          this.plyr3Name = name;
          break;
      }
    },
    setAutoPlaysCount(autoPlaysCount) {
      this.autoPlaysCount = autoPlaysCount;
    },
    getOnPlaying() {
      const vm = this;
      return () => {
        vm.$emit('playing');
      };
    },
    getOnPlay() {
      const vm = this;
      return () => {
        vm.$emit('play');
      };
    },
    getOnPause() {
      const vm = this;
      return () => {
        vm.$emit('pause');
      };
    },
    getOnLoadedData(plyr, plyrElement) {
      const vm = this;
      return () => {
        if (plyr.duration > 0) {
          if (this.playSync && this.playSync.numberPlayId === plyr.gamePlay.playId && !this.playSync.booleanIsApplied) {
            this.playSync.booleanIsApplied = true;
            plyr.currentTime = this.playSync.numberCurrentTime;
          } else {
            plyr.currentTime = plyr.gamePlay.startSeconds;
          }
        }
        if (vm.isAutoPlayLocal && vm.currentPlayer === plyrElement) {
          vm.playCurrentVideoPlayer();
        }
      };
    },
    getPlyrOptions() {
      return {
        autoplay: false,
        speed: { selected: 1, options: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] },
        invertTime: false,
        muted: false,
        seekTime: 10,
        controls: this.getVideoPlayerOptions(),
        // ratio: '47:20',
      };
    },
    getVideoPlayerOptions() {
      if (this.$route.name === 'mediaplayer' || this.$route.name === 'home' || this.isGs) {
        return [
          'play-large', // The large play button in the center
          'play', // Play/pause playback
          'rewind', // Rewind by the seek time (default 10 seconds)
          'fast-forward', // Fast forward by the seek time (default 10 seconds)
          'progress', // The progress bar and scrubber for playback and buffering
          'current-time', // The current time of playback
          'duration', // The full duration
          'volume', // The volume
          // 'fullscreen', // Toggle fullscreen
        ];
      }
      return [
        'play-large', // The large play button in the center
        'rewind', // Rewind by the seek time (default 10 seconds)
        'play', // Play/pause playback
        'fast-forward', // Fast forward by the seek time (default 10 seconds)
        'current-time', // The current time of playback
        // 'fullscreen', // Toggle fullscreen
      ];
    },
    playCurrentVideoPlayer() {
      const currentVideoPlayer = this[this.pivotPlayers.current];
      if (currentVideoPlayer) {
        this.setAutoPlaysCount(this.autoPlaysCount + 1);
        currentVideoPlayer.muted = false;
        currentVideoPlayer.play();
      }
    },
    moveToGamePlays(gameId) {
      let firstGamePlayIndex = 0;
      for (let i = 0; i < this.playerQueue.length; i++) {
        firstGamePlayIndex = i;
        if (this.playerQueue[i].gameId === gameId) {
          break;
        }
      }
      this.setAutoPlaysCount(this.autoPlaysCount - 1);
      this.resetPlayersSrc();
      this.currentPlayIndex = firstGamePlayIndex;
      this.setPlyrSrc();
    },
    addSecondsToCurrentPlayer(numberSeconds) {
      if (this[this.pivotPlayers.current]) {
        this[this.pivotPlayers.current].currentTime += numberSeconds;
      }
    },
    setSpeedToAllPlayers(speed) {
      if (this[this.pivotPlayers.current]) {
        this[this.pivotPlayers.current].speed = speed;
      }
      if (this[this.pivotPlayers.next]) {
        this[this.pivotPlayers.next].speed = speed;
      }
      if (this[this.pivotPlayers.last]) {
        this[this.pivotPlayers.last].speed = speed;
      }
    },
    setUpPlayInteraction(booleanIsFromButton) {
      this.$emit('play-iteration', {
        iterationTime: booleanIsFromButton ? this.currentPlay.currentTime : null,
        userAction: booleanIsFromButton ? 0 : 1,
        dateTimeIsoString: new Date().toISOString().split('.')[0],
      });
    },
    onTimeUpdate(plyrElement) {
      const vm = this;
      return () => {
        if (plyrElement !== vm.currentPlayer || vm[vm.currentPlayer].gamePlay.endSeconds === null) return;
        if (vm[vm.currentPlayer].currentTime >= vm[vm.currentPlayer].gamePlay.endSeconds) {
          if (!vm[vm.currentPlayer].paused) {
            vm.onNextPlayClicked();
          }
        }
      };
    },
    onNextPlayClicked(isFromButton = false) {
      this.setUpPlayInteraction(isFromButton);
      if (isFromButton) {
        this.autoPlaysCount = 0;
      }
      this.pausePlayers();
      if (this.currentPlayIndex < this.playerQueue.length - 1) {
        const currentAux = this.pivotPlayers.current;
        this.currentPlayIndex += 1;
        this.currentPlayer = this.pivotPlayers.next;
        this.pivotPlayers.current = this.currentPlayer;
        this.pivotPlayers.next = this.pivotPlayers.last;
        this.pivotPlayers.last = currentAux;
        this.setCurrentPlay();
        this.playCurrentVideoPlayer();
        this.setUpNewNextAndLast('next');
      } else {
        this.resetPlayersSrc();
        this.$emit('playlist-ended');
      }
    },
    onLastPlayClicked() {
      this.autoPlaysCount = 0;
      this.pausePlayers();
      if (this.currentPlayIndex > 0) {
        this.currentPlayIndex -= 1;
        const currentAux = this.pivotPlayers.current;
        this.currentPlayer = this.pivotPlayers.last;
        this.pivotPlayers.current = this.currentPlayer;
        this.pivotPlayers.last = this.pivotPlayers.next;
        this.pivotPlayers.next = currentAux;
        this.playCurrentVideoPlayer();
        this.setCurrentPlay();
        this.setUpNewNextAndLast('last');
      } else {
        this[this.currentPlayer].currentTime = this[this.currentPlayer].gamePlay.startSeconds;
      }
    },
    setFullscreen() {
      if (this.currentPlayer) {
        this[this.currentPlayer].fullscreen.enter();
      }
    },
    resetPlayersSrc() {
      Object.values(this.pivotPlayers).forEach(value => {
        if (value) {
          const videoPlayer = this[this.pivotPlayers[value]];
          if (videoPlayer && this[this.pivotPlayers[value]]) {
            this[this.pivotPlayers[value]].pause();
            this[this.pivotPlayers[value]].removeAttribute('src'); // empty source
            this[this.pivotPlayers[value]].load();
          }
        }
      });
    },
    pausePlayers() {
      if (this[this.pivotPlayers.current]) {
        this[this.pivotPlayers.current].pause();
      }
      if (this[this.pivotPlayers.last]) {
        this[this.pivotPlayers.last].pause();
      }
      if (this[this.pivotPlayers.next]) {
        this[this.pivotPlayers.next].pause();
      }
    },
    setCurrentPlay() {
      this.currentPlay = this.playerQueue[this.currentPlayIndex];
    },
    setUpNewNextAndLast(action) {
      if (action === 'next') {
        const nextGamePlay = this.playerQueue[this.nextPlayIndex];
        const lastGamePlay = this[this.pivotPlayers.last].gamePlay;
        if (lastGamePlay) {
          this[this.pivotPlayers.last].currentTime = lastGamePlay.startSeconds;
          this[this.pivotPlayers.last].pause();
        }
        if (nextGamePlay) {
          this[this.pivotPlayers.next].gamePlay = nextGamePlay;
          this[`keyP${this[this.pivotPlayers.next].id}`]++;
          this[this.pivotPlayers.next].source = this.getSrcObject(nextGamePlay);
        }
      } else if (action === 'last') {
        const nextGamePlay = this[this.pivotPlayers.next].gamePlay;
        if (nextGamePlay) {
          this[this.pivotPlayers.next].currentTime = nextGamePlay.startSeconds;
          this[this.pivotPlayers.next].pause();
        }
        if (this.currentPlayIndex > 0) {
          const lastGamePlay = this.playerQueue[this.lastPlayIndex];
          this[this.pivotPlayers.last].gamePlay = lastGamePlay;
          this[`keyP${this[this.pivotPlayers.last].id}`]++;
          this[this.pivotPlayers.last].source = this.getSrcObject(lastGamePlay);
        }
      }
    },
    stopVideoPlayers() {
      if (this[this.pivotPlayers.current]) {
        this[this.pivotPlayers.current].stop();
      }
      if (this[this.pivotPlayers.next]) {
        this[this.pivotPlayers.next].stop();
      }
      if (this[this.pivotPlayers.last]) {
        this[this.pivotPlayers.last].stop();
      }
    },
    playCurrentPlayer() {
      if (this[this.pivotPlayers.current]) {
        this[this.pivotPlayers.current].play();
      }
    },
    setPlyrSrc() {
      try {
        this.stopVideoPlayers();
        if (this.playerQueue && this.playerQueue.length) {
          this.currentPlayer = this.plyr1Name;
          this.pivotPlayers.current = this.plyr1Name;
          this.pivotPlayers.next = this.plyr2Name;
          this.pivotPlayers.last = this.plyr3Name;
          const firstGamePlay = this.playerQueue[this.currentPlayIndex];
          const nextGamePlay = this.playerQueue[this.nextPlayIndex];
          const lastGamePlay = this.playerQueue[this.lastPlayIndex];
          this[this.plyr1Name].source = this.getSrcObject(firstGamePlay);
          this[this.plyr1Name].gamePlay = firstGamePlay;
          this.currentPlay = firstGamePlay;
          this[this.plyr1Name].nextGamePlay = nextGamePlay;
          if (nextGamePlay) {
            if (this[this.plyr2Name]) {
              this[this.plyr2Name].source = this.getSrcObject(nextGamePlay);
              this[this.plyr2Name].gamePlay = nextGamePlay;
            }
          }
          if (lastGamePlay) {
            if (this[this.plyr3Name]) {
              this[this.plyr3Name].source = this.getSrcObject(lastGamePlay);
              this[this.plyr3Name].gamePlay = lastGamePlay;
            }
          }
        }
      } catch (e) {
        throw new Error(e);
      }
    },
    getSrcObject(gamePlay) {
      return {
        type: 'video',
        sources: [
          {
            src: `${this.baseUrl}/${gamePlay.gameId}_1.mp4`,
            type: 'video/mp4',
            size: 720,
          },
        ],
      };
    },
    play() {
      this[this.plyr1Name].currentTime = this[this.plyr1Name].gamePlay.startSeconds;
      this[this.plyr1Name].play();
    },
    clearPlayers() {
      this[this.plyr1Name] = null;
      this[this.plyr2Name] = null;
      this[this.plyr3Name] = null;
      this[this.plyr4Name] = null;
    },
    onMoveToPlayClicked(type) {
      if (type === 'next') {
        this.onNextPlayClicked(true);
      } else if (type === 'back') {
        this.onLastPlayClicked();
      }
    },
    fetchPlyr() {
      const vm = this;
      let script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.plyr.io/3.7.8/plyr.js');
      script.setAttribute('type', 'application/javascript');
      document.body.appendChild(script);

      // now wait for it to load...
      script.onload = () => {
        vm.plyrInit();
      };
    },
  },
  created() {
    EventBus.$on('play-video', isModalMode => {
      if (isModalMode === this.isModalMode) {
        this.play();
      }
    });
  },
  mounted() {
    try {
      this.fetchPlyr();
    } catch (e) {
      throw new Error(e);
    }
  },
  beforeDestroy() {
    this.pendingPlayerQueue = [];
    this.clearPlayers();
    this.$store.commit(`${this.storeModule}/setPlaylistIndex`, {
      mediaPlayerType: null,
      playlistIndex: 0,
    });
  },
};
</script>

<style scoped lang="scss">
.video-player {
  display: flex;
  flex-direction: column;
  width: 100%;

  &__play-buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.country-block {
  position: relative;
  width: 100%;

  &:before {
    content: '';
    display: block;
    padding-top: 56%;
  }

  & > div.content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f6fafc;
  }
}

.move-to-play-button__icon {
  height: 40px;
  width: 40px;

  @media screen and (max-width: 640px) {
    height: 30px;
    width: 30px;
  }
}

.move-to-play-button__text {
  font-size: 1.3rem;
  font-family: Avenir-Medium, sans-serif;

  @media screen and (max-width: 640px) {
    font-size: 0.8rem;
  }

  @media screen and (max-width: 420px) {
    display: none;
  }

  &-mobile {
    @media screen and (min-width: 420px) {
      display: none;
    }
  }
}
</style>
<style lang="scss">
.video-player {
  & div.plyr-controls {
    & div.plyr__controls > button.plyr__controls__item.plyr__control {
      &:nth-child(1) {
        margin-right: 0 !important;
      }
      &:nth-child(3) {
        margin-right: auto !important;
      }
    }
  }
}
</style>
